import { KeycloakRealm } from '../types'

export const setRealmInStorage = (currentRealm: KeycloakRealm): void =>
  localStorage.setItem('CURRENT_REALM', currentRealm)

export const getRealmFromStorage = (): KeycloakRealm =>
  (localStorage.getItem('CURRENT_REALM') as KeycloakRealm) || 'Ambev'

export const setIdTokenInStorage = (idToken: string | null): void =>
  idToken === null ? localStorage.removeItem('ID_TOKEN') : localStorage.setItem('ID_TOKEN', idToken)

export const getIdTokenFromStorage = (): string | null => localStorage.getItem('ID_TOKEN')
